import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { CkNormeValues } from '../common/models/amm-controllo.type';
import { checkCkNorme, ruleGuard } from './amm-controllo-validators.helpers';
import { ammUnicoRules } from './amm-controllo-amm-unico.rules';
import { collegioSindacaleRules } from './amm-controllo-collegio-sindacale.rules';
import { consiglioAmministrazioneRules } from './amm-controllo-consiglio-amm.rules';
import { liquidatoriRules } from './amm-controllo-liquidatori.rules';
import { revisoriRules } from './amm-controllo-revisori.rules';
import { formPaths } from '@shared/constants/form-paths.const';

export const ammControlloCommonRules = (ckNormeTargetValue: CkNormeValues): FormGroupRules => ({
    my_CkNorme: (form: FormGroup) => {
        const my_CkNormeControl = getControl(form, `${formPaths.ammControllo}.my_CkNorme`);
        const errors = my_CkNormeControl.errors ? my_CkNormeControl.errors : {};

        addRemoveError(isNilOrEmpty(my_CkNormeControl?.value), errors, 'my_CkNorme', {
            status: 'Errore',
        });

        my_CkNormeControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_CkOrgSocietCorrCostit: (form: FormGroup) => {
        ruleGuard(form, ckNormeTargetValue, [], () => {
            const my_CkOrgSocietCorrCostitControl = getControl(form, `${formPaths.ammControllo}.my_CkOrgSocietCorrCostit`);
            const errors = my_CkOrgSocietCorrCostitControl.errors ? my_CkOrgSocietCorrCostitControl.errors : {};

            addRemoveError(isNilOrEmpty(my_CkOrgSocietCorrCostitControl?.value) && checkCkNorme(form, ckNormeTargetValue as CkNormeValues), errors, 'my_CkOrgSocietCorrCostit', {
                status: REQUIRED_STATUS,
            });

            my_CkOrgSocietCorrCostitControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    my_CkOrgSocietCorrFunz: (form: FormGroup) => {
        ruleGuard(form, ckNormeTargetValue, [], () => {
            const my_CkOrgSocietCorrFunzControl = getControl(form, `${formPaths.ammControllo}.my_CkOrgSocietCorrFunz`);
            const errors = my_CkOrgSocietCorrFunzControl.errors ? my_CkOrgSocietCorrFunzControl.errors : {};

            addRemoveError(isNilOrEmpty(my_CkOrgSocietCorrFunzControl?.value) && checkCkNorme(form, ckNormeTargetValue as CkNormeValues), errors, 'my_CkOrgSocietCorrFunz', {
                status: REQUIRED_STATUS,
            });

            my_CkOrgSocietCorrFunzControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    my_NoteEdOsservazioni: (form: FormGroup) => {
        ruleGuard(form, ckNormeTargetValue, [], () => {
            const my_NoteEdOsservazioniControl = getControl(form, `${formPaths.ammControllo}.my_NoteEdOsservazioni`);
            const errors = my_NoteEdOsservazioniControl.errors ? my_NoteEdOsservazioniControl.errors : {};

            addRemoveError(isNilOrEmpty(my_NoteEdOsservazioniControl?.value) && checkCkNorme(form, ckNormeTargetValue as CkNormeValues), errors, 'my_NoteEdOsservazioni', {
                status: REQUIRED_STATUS,
            });

            my_NoteEdOsservazioniControl.setErrors(isEqual(errors, {}) ? null : errors);
        });
    },

    ...ammUnicoRules(ckNormeTargetValue),
    ...collegioSindacaleRules(ckNormeTargetValue),
    ...consiglioAmministrazioneRules(ckNormeTargetValue),
    ...liquidatoriRules(ckNormeTargetValue),
    ...revisoriRules(ckNormeTargetValue),
});

export const ammControlloFormValidators = (ckNormeTargetValue: CkNormeValues) => {
    return Object.values(ammControlloCommonRules(ckNormeTargetValue));
};
